var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.34807C0 1.87347 0.184374 1.41831 0.512563 1.08272C0.840752 0.747127 1.28587 0.558594 1.75 0.558594H26.25C26.7141 0.558594 27.1592 0.747127 27.4874 1.08272C27.8156 1.41831 28 1.87347 28 2.34807V16.6639C28 17.1385 27.8156 17.5936 27.4874 17.9292C27.1592 18.2648 26.7141 18.4533 26.25 18.4533H1.75C1.28587 18.4533 0.840752 18.2648 0.512563 17.9292C0.184374 17.5936 0 17.1385 0 16.6639V2.34807ZM5.25 2.34807C5.25 3.29726 4.88125 4.20758 4.22487 4.87877C3.5685 5.54995 2.67826 5.92701 1.75 5.92701V13.0849C2.67826 13.0849 3.5685 13.462 4.22487 14.1332C4.88125 14.8043 5.25 15.7147 5.25 16.6639H22.75C22.75 15.7147 23.1187 14.8043 23.7751 14.1332C24.4315 13.462 25.3217 13.0849 26.25 13.0849V5.92701C25.3217 5.92701 24.4315 5.54995 23.7751 4.87877C23.1187 4.20758 22.75 3.29726 22.75 2.34807H5.25Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91406 9.47508C9.91406 8.42393 10.3316 7.41584 11.0749 6.67256C11.8182 5.92929 12.8263 5.51172 13.8774 5.51172C14.9286 5.51172 15.9367 5.92929 16.6799 6.67256C17.4232 7.41584 17.8408 8.42393 17.8408 9.47508C17.8408 10.5262 17.4232 11.5343 16.6799 12.2776C15.9367 13.0209 14.9286 13.4384 13.8774 13.4384C12.8263 13.4384 11.8182 13.0209 11.0749 12.2776C10.3316 11.5343 9.91406 10.5262 9.91406 9.47508ZM13.6513 11.1714L15.9331 8.31884L15.5209 7.98909L13.5752 10.4205L12.197 9.27216L11.8588 9.67801L13.6513 11.1714Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDevicesIcon);
export default __webpack_public_path__ + "static/media/all-devices-icon.e0263a799a020e326ddc0b1f4ba533a6.svg";
export { ForwardRef as ReactComponent };